module.exports = __webpack_public_path__ + "static/media/Smart Campus_logo.563e90de.png";